export default {
  form: {
    name: '名称',
    placeholder: '请输入',
    nameEmptyWarning: '名称不能为空',
  },
}
